module.exports = __webpack_public_path__ + "img/popup-game-sucai.3966b360.png";